import {styled} from "@mui/material";

export const Container = styled('span')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  margin: '0 20px',
});
